/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliActivityDto } from '../../models/amoxcalli-activity-dto';
import { AmoxcalliCreateActivityDto } from '../../models/amoxcalli-create-activity-dto';

export interface ApiActivitiesPost$Plain$Params {
      body?: AmoxcalliCreateActivityDto
}

export function apiActivitiesPost$Plain(http: HttpClient, rootUrl: string, params?: ApiActivitiesPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AmoxcalliActivityDto>> {
  const rb = new RequestBuilder(rootUrl, apiActivitiesPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmoxcalliActivityDto>;
    })
  );
}

apiActivitiesPost$Plain.PATH = '/api/activities';
